import { Card, Grid, Table } from '@mantine/core';
import ProductCard from '../../components/Products/ProductCard';

const ProductDetailsTab = ({ product, productProperties }) => {
  return (
    <Card withBorder>
      <Grid>
        <Grid.Col span={{ base: 12, sm: 4 }}>
          <ProductCard product={product} />
        </Grid.Col>
        <Grid.Col span={{ base: 12, sm: 4 }} style={{ overflow: 'auto' }}>
          <Table striped withTableBorder withColumnBorders highlightOnHover>
            <Table.Tbody>{productProperties.slice(0, 2)}</Table.Tbody>
            <Table.Tbody>{productProperties[2]}</Table.Tbody>
            <Table.Tbody>{productProperties.slice(3, 7)}</Table.Tbody>
          </Table>
        </Grid.Col>
        <Grid.Col span={{ base: 12, sm: 4 }} data-tour="productItem" style={{ overflow: 'auto' }}>
          <Table striped withTableBorder withColumnBorders highlightOnHover>
            <Table.Tbody>{productProperties.slice(7)}</Table.Tbody>
          </Table>
        </Grid.Col>
      </Grid>
    </Card>
  );
};

export default ProductDetailsTab;
